import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export default function LegalLayout({ title, children }) {
  return (
    <div className="bg-cream min-h-screen">
      <header className="border-b border-umber/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo">
            <Logo />
          </Link>
          <Link to="/" className="font-sans text-sm text-ink hover:text-charcoal">Zurück</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <p className="label-eyebrow mb-6">Rechtliches</p>
        <h1 className="font-serif text-4xl md:text-5xl text-charcoal leading-tight mb-12">{title}</h1>
        <div className="prose-oratio">{children}</div>
      </main>
      <footer className="py-12 border-t border-umber/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap gap-6 font-sans text-sm text-ink">
          <Link to="/kontakt" className="hover:text-charcoal">Kontakt</Link>
          <Link to="/impressum" className="hover:text-charcoal">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-charcoal">Datenschutz</Link>
          <Link to="/agb" className="hover:text-charcoal">AGB</Link>
        </div>
      </footer>
    </div>
  );
}
